'use client';

import { FULL_STORY_INITIALIZATION_DELAY } from '@finn/ua-constants';
import {
  CookieKeys,
  getIsInternalUser,
  isAllConsentTrue,
  UCConsentEvent,
} from '@finn/ui-utils';
import Cookies from 'js-cookie';
import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';

export const FullStory: React.FunctionComponent = () => {
  const pathname = usePathname();

  useEffect(() => {
    window.addEventListener('afterConsent', (event: Event) => {
      const consent = event as UCConsentEvent;
      const detail = { ...consent.detail };
      const isInternalUser = getIsInternalUser();
      const isFullStoryEnabled =
        Cookies.get(CookieKeys.FULLSTORY_DE) === 'enabled';
      if (detail?.type === 'explicit' || isAllConsentTrue(detail)) {
        if (
          isFullStoryEnabled &&
          !isInternalUser &&
          !!detail.Fullstory === true
        ) {
          window.dataLayer = window.dataLayer || [];
          setTimeout(() => {
            window.dataLayer?.push({ event: 'FullStoryCookie' });
          }, FULL_STORY_INITIALIZATION_DELAY);
        }
      }
    });
  }, []);

  // force load fullstory on checkout pages if not already loaded
  useEffect(() => {
    const isInternalUser = getIsInternalUser();
    if (isInternalUser) return;
    const hasConsent = window.UC_Integrations?.FullStory;
    const isFullStoryLoaded = Boolean(window.FS);

    if (pathname?.includes('/checkout/') && hasConsent && !isFullStoryLoaded) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'FullStoryCookie' });
    }
  }, [pathname]);

  return null;
};
